export function formatPrice(value, currency = "EUR") {
  if (value === null || value === undefined) return "";
  const cur = (currency || "EUR").toUpperCase();
  const locale = cur === "GBP" ? "en-GB" : "fr-FR";
  return new Intl.NumberFormat(locale, { style: "currency", currency: cur }).format(value);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "long", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
  } catch {
    return iso;
  }
}
